// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_69e3fb7c","imageLink":"_fe7878a8","image":"_9c9e3848","placeholder":"_bb01068c","name":"_6e8bcc28","nameLink":"_38dcb0c8"};